<template>
    <div class="col-12 d-flex dashboard">
        <div class="w-100">
            <div class="row">
                <ArtistTable :artists="allData" />
                <VenueTable :venues="allData" />
                <UserTable :users="allData" />
                <TransactionsTable :transactions="allData" />
            </div>
        </div>
    </div>
</template>

<script>
import ArtistTable from './ArtistTable.vue'
import VenueTable from './VenueTable.vue'
import UserTable from './UserTable.vue'
import TransactionsTable from './TransactionsTable.vue'
import KPI from '../../KPI.vue'

export default {
    name: 'FinanceDashboard',
    components: {
        ArtistTable,
        VenueTable,
        UserTable,
        TransactionsTable,
        KPI
    },
    data: () => ({
        url: '/admin/dashboard/getBizDev',
        allData: '',
    })
}
</script>
